import { Modify } from "@biblioteksentralen/types";
import { Litteraturpris, LitteraturprisTemplateContent, Promotion } from "@libry-content/types";
import groq from "groq";
import { getTemplateContentPromotionFilter } from "../promotion/utils";
import { resolveEventsReferences } from "./sommerlesGroq";
import { ResolvedEventSummary } from "../events";

export const litteraturprisGroqFilter = getTemplateContentPromotionFilter("litteraturpris");

export const resolveLitteraturprisGroqProjection = groq`
  ...,
  templateContent->,
  "events": ${resolveEventsReferences},
  "promotion": templateContent->promotion
`;

export type ResolvedLitteraturpris = Modify<
  Litteraturpris,
  {
    events: ResolvedEventSummary[] | null;
    templateContent: LitteraturprisTemplateContent;
  } & { promotion: Promotion }
>;

export const resolveLitteraturprisBannerDataGroqProjection = groq`
  _id, _type, separatePage, startDate, endDate, templateContent->, "promotion": templateContent->promotion,
`;

export type ResolvedLitteraturprisBannerData = Pick<
  ResolvedLitteraturpris,
  "_id" | "_type" | "separatePage" | "startDate" | "endDate" | "promotion"
> & {
  templateContent: LitteraturprisTemplateContent;
};
